import script from "./Roleadd.vue?vue&type=script&setup=true&lang=js"
export * from "./Roleadd.vue?vue&type=script&setup=true&lang=js"

import "./Roleadd.vue?vue&type=style&index=0&id=ca8e9a04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca8e9a04"]])

export default __exports__